import React, { useState } from 'react';
import axiosInstance from './axiosInstance';

function LoginForm() {
  const [username, setUsername] = useState('');  // Can be username or email
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axiosInstance.post('http://127.0.0.1:8000/api/token/', {
        username,  // Backend accepts email or username in this field
        password,
      });
      localStorage.setItem('access', res.data.access);
      localStorage.setItem('refresh', res.data.refresh);
      window.location.href = '/branches';
    } catch (err) {
      alert('Login failed - Invalid email/username or password');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input 
        type="text" 
        placeholder="Email or Username" 
        value={username} 
        onChange={(e) => setUsername(e.target.value)} 
        required
      />
      <input 
        type="password" 
        placeholder="Password" 
        value={password} 
        onChange={(e) => setPassword(e.target.value)} 
        required
      />
      <button type="submit">Login</button>
    </form>
  );
}

export default LoginForm;